<script lang="ts">
	import britLogo from "@assets/images/brit-logo.svg";
	import nyroLogo from "@assets/images/nyro-logo.svg?raw";
	import Icon from "@components/common/Icon.svelte";
	import Media from "@components/common/Media.svelte";
	import { getTranslate } from "@utils/translate.js";
	import translations from "./Footer.translations.json" with { type: "json" };

	const { noMargin }: { noMargin?: boolean } = $props();

	const translate = getTranslate(translations);
</script>

<footer class={["grid-container relative bg-black text-white", { "mt-16": !noMargin }]}>
	<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-16 lg:gap-8 pt-20 py-16">
		<div class="flex flex-col gap-2">
			<strong class="mb-1 h3">{translate("headquarters")}</strong>
			<p class="text-sm font-semibold">DiscDog klub České republiky z.s.</p>
			<address class="text-sm">U Pergamenky 1511/3,<br />Holešovice 170 00 Praha 7</address>
			<p class="text-sm">IČ: 27040925</p>
			<p class="text-sm">DIČ: CZ27040925</p>
		</div>
		<div class="flex flex-col gap-2">
			<strong class="mb-1 h3">{translate("bank")}</strong>
			<p class="text-sm">
				Bank number: <span class="font-semibold">2200958095/2010</span> <span class="block">(Fio Banka)</span>
			</p>
			<p class="text-sm">IBAN: CZ5020100000002200958095</p>
			<p class="text-sm">BIC/SWIFT: FIOBCZPPXXX</p>
		</div>

		<div class="flex flex-col gap-2">
			<strong class="mb-1 h3">{translate("contactUs")}</strong>
			<p class="text-sm">Phone: +420 <span class="font-semibold">703 575 362</span></p>
			<p class="text-sm">Email: <span class="font-semibold">discdogklub@gmail.com</span></p>
		</div>
		<div class="flex flex-col gap-2">
			<div class="rounded-md bg-white px-6 py-4 w-fit max-w-72">
				<Media
					class="max-md:w-32 max-w-48"
					source={{ src: britLogo, type: "image/svg+xml" }}
					width={474}
					height={422}
					alt="DiscDog Club logo"
				></Media>
				<p class="text-xs max-w-44 mt-3 leading-normal text-black">{translate("partner")}</p>
			</div>
		</div>
	</div>
	<div class="full-width grid-container pt-8 pb-20 text-sm text-center bg-black text-white">
		<div class="flex flex-col items-center gap-2">
			<Icon icon={nyroLogo} class="h-24 text-white" />
			<div>Developed with ❤️ by Nyro</div>
			<div>&copy; 2025</div>
		</div>
	</div>
</footer>
